import styled from "styled-components";

export const EditableTableContainer = styled.div<{ isLoading: boolean }>`
	${props => (props.isLoading ? `opacity:0.2` : ``)};
`;

export const EditableTableExplanation = styled.div`
	margin-bottom: 1em;
`;
